import { render, staticRenderFns } from "./PlansTabsSection.vue?vue&type=template&id=4c27ca15&scoped=true"
import script from "./PlansTabsSection.vue?vue&type=script&lang=js"
export * from "./PlansTabsSection.vue?vue&type=script&lang=js"
import style0 from "./PlansTabsSection.vue?vue&type=style&index=0&id=4c27ca15&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c27ca15",
  null
  
)

export default component.exports